export default {
  title: "Профиль компании",
  profileComplete: "Заполнен",
  profileNotComplete: "Частично заполнен",

  modal: {
    logo: "Логотип компании",
    logoDescription: "В форматах png, jpg, jpeg.",
    logoSize: "Максимальный размер файла - 2 мб",
    logoResolution: "Максимальное разрешение 1024x1024",
    logoLoadBtn: "Загрузить",
    logoRemoveBtn: "Удалить",
    logoLoadingBtn: "Загрузка {name}...",

    companyNameLang1: "Наименование компании",
    companyNameLang2: "Наименование компании на английском",

    country: "Страна",

    email: "Электронная почта",

    addressForm: {
      title: "Фактический адрес",
      address: "Адрес"
    },

    mailingAddress: "Почтовый адрес",

    companyPhone: "Телефон компании",
    companyFax: "Факс",

    rubricatorTitle: "Рубрикатор",

    inn: "ИНН",
    okved: "ОКВЭД",

    companyTypes: "Вид деятельности",
    companySizes: "Выберите, если это относится к Вашей компании",
    companyScope: "Сфера деятельности вашей компании",
    companyProductRole: "Сфера продукции вашей компании",

    counterpartyShowBtn: "Посмотреть данные контрагента",
    counterpartyHideBtn: "Скрыть данные контрагента",

    counterpartyName: "Наименование контрагента",
    counterpartyLegalAddress: "Юридический адрес",
    counterpartyKpp: "КПП",
    counterpartyBank: "Банк",
    counterpartyBik: "БИК",
    counterpartyCorAccount: "Корреспондентский счет",
    counterpartyCheckAccount: "Расчетный счет",

    submit: "Сохранить",
    submitting: "Сохраняем...",
    websiteError:
      " Поле может содержать буквы кириллицы, латинские буквы, числа, знаки\n" +
      "          дефиса, нижнего подчеркивания, двоеточие, точку, слеш."
  }
};
